import React, { PropsWithChildren } from 'react';

export function Content({ children }: PropsWithChildren<unknown>) {
  return <p className="status-info__content">{children}</p>;
}
